var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.503,
    height: 18.043,
    viewBox: "0 0 15.503 18.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(-1119.743 -642.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    transform: "translate(1123.067 647)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 3.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M1137.275,615.209c1.358-3.721,3.7-5.909,6.942-5.909s5.282,2.113,6.64,5.909",
    transform: "translate(-16.569 36.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x1: 9,
    y2: 16,
    transform: "translate(1123.067 643.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.d04ded86.svg";
export { ForwardRef as ReactComponent };